(function () {
    'use strict';

    angular
        .module('sodCommon')
        .directive('sodOptionToggle', sodOptionToggle);

    function sodOptionToggle() {
        return {
            restrict: 'E',
            scope: {
                option: '=',
                labelText: '=',
            },
            template:'<label class="sod-option-toggle" ng-click="toggle()"><i class="fa fa-circle" ng-class="{ \'activated\': toggleState, \'deactivated\':!toggleState  }"></i> <%labelText%></label>',
            require: 'ngModel',
            link:function(scope, elem, attr, ctrl) {
                scope.toggleState = false;

                scope.toggle = function() {
                  scope.toggleState = !scope.toggleState;
                    ctrl.$setViewValue(scope.toggleState);
                };

                ctrl.$formatters.push(function(modelValue) {
                    return modelValue;
                });
                ctrl.$parsers.push(function(viewValue) {
                    return viewValue;
                });

                ctrl.$render = function(modelValue) {
                    scope.toggleState = modelValue;
                };
            }
        };
    }
})();